class CartDrawer extends ModalComponent {
  constructor() {
    super();
    this.boundCartAddons = /* @__PURE__ */ new WeakSet();
    this.toggleOverlayCartAddons();
    this.getSectionToRenderListener = this.getSectionToRender.bind(this);
  }
  cartUpdateUnsubscriber = void 0;
  quickViewShowUnsubscriber = void 0;
  connectedCallback() {
    super.connectedCallback();
    this.quickViewShowUnsubscriber = GSP.pubsub.subscribe(
      GSP.pubsub.PUB_SUB_EVENTS.quickViewShow,
      this.onQuickViewShow.bind(this)
    );
    this.cartUpdateUnsubscriber = GSP.pubsub.subscribe(
      GSP.pubsub.PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "product-form") {
          let productForm = event.target;
          if (productForm.closest("quick-view")) {
            let quickView = productForm.closest("quick-view");
            this.show(quickView.lastTrigger);
          } else {
            this.show(productForm.submitter);
          }
        }
      }
    );
    document.addEventListener("cart:grouped-sections", this.getSectionToRenderListener);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.quickViewShowUnsubscriber) {
      this.quickViewShowUnsubscriber();
    }
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
    document.removeEventListener("cart:grouped-sections", this.getSectionToRenderListener);
  }
  getSectionToRender(event) {
    event.detail.sections.push(gspTheme.helper.getSectionId(this));
  }
  onShowHandler() {
    GSP.carousel.initMultiSwiper(this);
  }
  onQuickViewShow(event) {
    this.hide();
  }
  toggleOverlayCartAddons() {
    if (this.querySelectorAll(".collapse")) {
      this.querySelectorAll(".collapse").forEach((element) => {
        if (this.boundCartAddons.has(element)) {
          return;
        }
        this.boundCartAddons.add(element);
        element.addEventListener("hidden.bs.collapse", (event) => {
          this.activeOverlay(false);
        });
        element.addEventListener("show.bs.collapse", (event) => {
          this.activeOverlay();
        });
      });
    }
  }
  activeOverlay(active = true) {
    const innerCart = this.querySelector(".gsp-cart-drawer__inner");
    if (active) {
      if (!innerCart.classList.contains("showOverlay")) {
        innerCart.classList.add("showOverlay");
      }
    } else {
      if (innerCart.classList.contains("showOverlay")) {
        innerCart.classList.remove("showOverlay");
      }
    }
  }
}
customElements.define("cart-drawer", CartDrawer);
